import React, { useState, useEffect, useMemo } from "react";
import { Button, useMediaQuery } from "@mui/material";
import { useSessionTimer } from "../context/sessionContext";
import { useQueryClient } from "react-query";
import { USER_DATA_INFO_QUERY_KEY } from "src/shared/enums/useQueryKeys";
import RefreshIcon from "@mui/icons-material/Refresh";
import TimerIcon from "@mui/icons-material/Timer";
import { add, differenceInMinutes } from "date-fns";
import { useLogoutHandler } from "src/authentication/data-access/useLoginQuery";

function CountDownSessionTimer() {
  const { sessionTimer, resetSessionTimer, timerDuration, setTimerDuration } =
    useSessionTimer();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [showCountdown, setShowCountdown] = useState(!isSmallScreen);
  const queryClient = useQueryClient();
  const { mutate: logout } = useLogoutHandler();
  const timer = useMemo(() => {
    const endTime = add(sessionTimer, { minutes: timerDuration });
    const diff = differenceInMinutes(endTime, sessionTimer);
    if (diff === 0) {
      setShowCountdown(false);
      logout();
    }
    return differenceInMinutes(endTime, sessionTimer);
  }, [sessionTimer, timerDuration]);

  useEffect(() => {
    let interval: number | undefined;
    interval = setInterval(() => {
      setTimerDuration((prevTime: number) => prevTime - 1);
    }, 60 * 1000);
    return () => {
      clearInterval(interval);
    };
  }, [sessionTimer, showCountdown]);

  const resetTimer = () => {
    queryClient.invalidateQueries(USER_DATA_INFO_QUERY_KEY);
    resetSessionTimer();
  };

  return (
    <>
      {showCountdown && (
        <Button
          sx={{ fontSize: "1rem", color: "white" }}
          startIcon={<TimerIcon />}
          endIcon={<RefreshIcon />}
          onClick={() => resetTimer()}
        >
          {timer.toString().padStart(2, "0")}'
        </Button>
      )}
    </>
  );
}

export default CountDownSessionTimer;
